import { Component, Vue, Ref } from "vue-property-decorator";
import AddNew from './components/AddNew.vue'
import Edit from './components/Edit.vue'
// import AdvanceSearch from '../../ops/customer/components/advanceSearch.vue'
import AdvanceSearch from './components/AdvanceSearch.vue'
import {
  AuthorityDomainServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
const csp = new CustomerServiceProxy()
const adsp = new AuthorityDomainServiceProxy()

import R from 'ramda'

import '@/components/tableStyle/index.less'

const resetProp = (from, to) => R.pipe(R.prop(from), R.objOf(to))

const tranformTreeShape = (data) => {
  const setLabel = resetProp('title', 'label')
  const setValue = resetProp('id', 'value')
  const setChildren = R.pipe(
    R.prop('children'),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf('children'))
    )
  )

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(data)
}
@Component({
  components: {
    AddNew,
    Edit,
    AdvanceSearch
  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_action'),
        dataIndex: 'id',
        key: 'id',
        width: 80,
        customRender: (sort, _record, index) => {
          return (
            _record.id &&
            <a class="table-span" onClick={() =>this.editRecord(_record)}> { this.$t('edit') } </a>
          )
        },
      },
      {
        title: this.$t('page_material_customer_code'),
        dataIndex: 'code',
        key: 'code',
        width:200,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_ops_work_record_customer_name'),
        dataIndex: 'name',
        key: 'name',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_ops_work_record_contact_person'),
        dataIndex: 'contact',
        key: 'contact',
        width:200,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_tenant_contact_number'),
        dataIndex: 'tel',
        key: 'tel',
        width:200,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_ops_customer_province'),
        dataIndex: 'provinceName',
        key: 'provinceName',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_ops_customer_city'),
        dataIndex: 'cityName',
        key: 'cityName',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_ops_customer_detailed_address'),
        dataIndex: 'address',
        key: 'address',
        width:350,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_role_data_per'),
        dataIndex: 'createDept',
        key: 'createDept',
        width:250,
        customRender: (value, _record, index) => {
          return (
            _record.id &&
            <a-tree-select
              value={value}
              style="width: 100%"
              tree-data={this.treeData}
              disabled
              search-placeholder="请选择数据权限"
            />
          )
        },
      },
      {
        title: this.$t('page_material_more') + '1',
        dataIndex: 'extend1',
        key: 'extend1',
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '2',
        dataIndex: 'extend2',
        key: 'extend2',
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '3',
        dataIndex: 'extend3',
        key: 'extend3',
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '4',
        dataIndex: 'extend4',
        key: 'extend4',
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '5',
        dataIndex: 'extend5',
        key: 'extend5',
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      }
    ]
  };
  data = []
  cacheData = []
  selectedRowKeys = []
  addNewVisible = false
  editVisible= false
  item = {}
  searchKey = ""
  pagination = {
    showQuickJumper: true,
    showSizeChanger: true,
    total: 0,
    pageSize: 30,
    current: 1,
    advance: {}
  }
  selectedRow: any = {}
  selectedRowId = ''
  scrollY = 1080
  printVisible = false
  dataList = []
  advanceVisible = false
  treeData = []


  mounted() {
    this.$nextTick(() => {
      this.getList()
      this.getAuthorityDomainList()
    })
  }

  async getAuthorityDomainList() {
    const { data } = await adsp.getEnableTreeList()
    const tree = tranformTreeShape(data[0])
    tree.selectable = false
    this.treeData = [tree]
  }

  updated(){
    this.$nextTick(() => {
      const div = document.getElementById('black-main')
      this.scrollY = div ? div.clientHeight - 100 : 500
    })
  }

  async getList(){
    this.data = []
    let data:any = {}
    if(this.searchKey){
      data = await this.getKeyword()
    } else {
      data = await this.getAdvance()
    }
    if (data.records) {
      this.pagination.total = Number(data.total)
      this.pagination.current = Number(data.current)
      this.pagination.pageSize = Number(data.size)
      this.data = data.records
      if (JSON.stringify(this.selectedRow) === '{}') {
        this.selectedRow = this.data[0]
        this.selectedRowId = this.data[0].id
        // this.selectedRowKeys = [this.data[0].id]
      } else {
        this.selectedRowId = this.selectedRow.id
        // this.selectedRowKeys = [this.selectedRow.id]
      }

      let dataLength = data.records.length;
      let copy = JSON.parse(JSON.stringify(data.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }
      this.data = JSON.parse(JSON.stringify(copy));


    }
    
  }
  async getKeyword(){
   return await csp.getPageCustomer(
    undefined,
    this.pagination.current,
    this.searchKey,
    this.pagination.pageSize
    )
  }
  async getAdvance(){
    const advance = this.pagination.advance as any
    return await csp.getPageCustomerByCondition(
      this.pagination.current,
      advance,
      this.pagination.pageSize
      )
  }

  reload(){
    this.editVisible = false
    this.addNewVisible = false
    this.pagination.current = 1
    this.getList()
  }

  onSelectChange(selectedRowKeys) {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.selectedRowKeys = selectedRowKeys;
  }
  
  addNew(){
    this.addNewVisible = true
  }
  
  delete(){
    const ids = this.selectedRowKeys
    csp.deleteSupplier(ids).then(() =>{
      this.pagination.current = 1
      this.$message.success(this.$t('delete_success'))
      this.selectedRowKeys = []
      this.getList()
    })
  }
  changeSearch(value){
    this.searchKey = value.target.value
  }

  onSearch() {
    this.pagination.current = 1
    this.pagination.advance = {}
    this.getList()
  }

  addClose(){
    this.addNewVisible = false
  }

  editRecord(value){
    this.item = value
    console.log(value)
    this.editVisible = true
  }

  editClose(){
    this.editVisible = false
  }

  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    Object.assign(this.pagination, pager)
    this.getList()
  }
  
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  getData() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.data.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.code,
            name: item.name
          })
        }
      })
    })
  }

  printing() {
    this.getData()
    this.printVisible = true
    
  }
  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  
  toggleSearch() {
    // this.advanceVisible = true
    this.advanceVisible = !this.advanceVisible
  }

  closeToggleSearch(){
    this.advanceVisible = false
  }

  startToggleSearch(value){
    this.searchKey = ''
    this.pagination.advance = value
    this.advanceVisible = false
    this.getList()
  }

  clickRow(row) {
    this.selectedRow = row
    this.selectedRowId = row.id
    this.selectedRowKeys = [row.id]
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
  }

  
  render() {
    return (
      <blank-view>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_material_add_customer') }</a-button>
            <a-popconfirm title={ this.$t('delete_tips')} onConfirm={() => this.delete()}>
              <a-button type="danger" disabled={this.selectedRowKeys.length === 0}>{ this.$t('delete') }</a-button>
            </a-popconfirm>
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-left: 8px;" onClick={() =>this.printing()}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
          <a-button style="margin-right: 8px" onClick={() => this.toggleSearch()} class="heightSearch">
            {this.$t('advanced_search')}
            <a-icon type="filter" />
          </a-button>
            <a-input-search enterButton={this.$t('search')} placeholder={this.$t('keyword')} value={this.searchKey} style="width: 200px" onChange={value => this.changeSearch(value)} onSearch={() => this.onSearch()} />
          </div>
        </div>
        <div id="inner">
          <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            customRow={
            (row) => ({
              on: {
                click: () => {
                  this.clickRow(row)
                }
              }
            })}
            row-key="id"
            scroll={this.scrollY ? { y: this.scrollY, x: 2680 } : { x: 2680 }}
            row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange, getCheckboxProps: this.getCheckboxProps }}
            chooseArr={this.selectedRowKeys}
            onCancelChooseArr={this.cancelChooseArr}
          >
          </ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            show-total={total => `${ this.showTotal(total) }`}
            current={this.pagination.current}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            on-change={this.handleTableChange}
            on-showSizeChange={this.handleTableChange}
          />
          <edit visible={this.editVisible} item={this.item} onClose={() => this.editClose()} onReload={() => this.reload()}></edit>
        </div>
        <add-new visible={this.addNewVisible} onClose={() => this.addClose()} onReload={() => this.reload()}></add-new>
        <advance-search visible={this.advanceVisible} item={this.pagination.advance} onClose={() => this.closeToggleSearch()} onAdvanceSearch={value => this.startToggleSearch(value)}></advance-search>
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      </blank-view>
    )
  }
}
